import { ThemeIcon } from "@mantine/core";
import { knownIcon } from "@/lib/faq-icons";

/** A built-in step's header icon (`BuiltinStep.icon`); nothing when the name
 *  is unknown or unset. Decorative: the title next to it says it all. */
export function StepIcon({ name }: { name: string | null | undefined }) {
  const Icon = knownIcon(name);
  if (!Icon) return null;
  return (
    <ThemeIcon size={36} radius="xl" variant="light" style={{ flexShrink: 0 }} aria-hidden>
      <Icon size={20} />
    </ThemeIcon>
  );
}
